/** declare only http service related requests */

import { HttpTokens, PutAttendee, AttendeeUpdateBodyData } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description update attendee scores by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const AttendeeUpdate = (
  prefix: string = 'training/attendee/update',
  id: string,
  body: AttendeeUpdateBodyData,
  tokens: HttpTokens,
  hardRejection = true
): Promise<PutAttendee> => {
  const instance = new AxiosService({ method: 'put', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };
  console.log('AttendeeUpdate/json', JSON.stringify(body));

  return instance.client
    .put(`${prefix}/${id}`, JSON.stringify(body), config)
    .then((d: AxiosResponse<PutAttendee>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<PutAttendee>;
};
